import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App Error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f9fafb", fontFamily: "system-ui, sans-serif" }}>
          <div style={{ textAlign: "center", padding: "2rem" }}>
            <img src="/praroha-logo-header.png" alt="Praroha Greens" style={{ width: 80, height: 80, margin: "0 auto 1.5rem" }} />
            <h2 style={{ fontSize: "1.25rem", fontWeight: 600, color: "#2D5016", marginBottom: "0.5rem" }}>Something went wrong</h2>
            <p style={{ color: "#6b7280", marginBottom: "1.5rem" }}>Please refresh the page or try again.</p>
            <button
              onClick={() => { this.setState({ hasError: false }); window.location.href = "/"; }}
              style={{ padding: "0.625rem 1.5rem", background: "#2D5016", color: "#fff", border: "none", borderRadius: "9999px", cursor: "pointer", fontSize: "0.875rem" }}
            >
              Go to Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
